<template>
  <div class="center-box-register">
    <!-- <div class="login-tit">大兴生物医药产业基地智慧化危险废物管理平台</div> -->
    <!-- <div class="login-tit">
      <span>欢迎登录</span>
    </div> -->
    <div class="register-header">
      <div class="register-title">注册账号</div>
      <div class="link-login" @click="linkTo('login')">已有账号，立即登录</div>
    </div>

    <div class="center-box-main">
      <el-form :model="registerForm" :rules="rules" ref="registerForm" class="registerForm">


        <el-form-item prop="companyName" class="login-item add-login-item">
          <el-input placeholder="企业名称" prefix-icon="el-icon-user" v-model="registerForm.companyName"></el-input>
        </el-form-item>
        <el-form-item prop="uniformSocialCreditCode" class="login-item">
          <el-input placeholder="统一社会信用代码" prefix-icon="el-icon-postcard"
            v-model="registerForm.uniformSocialCreditCode"></el-input>
        </el-form-item>
        <el-form-item prop="password" class="login-item">
          <el-input placeholder="设置 6-18 位登录密码" prefix-icon="el-icon-lock" v-model="registerForm.password"
            :show-password="true"></el-input>
        </el-form-item>
        <el-form-item prop="repeatPassword" class="login-item">
          <el-input placeholder="再次输入登录密码" v-model="registerForm.repeatPassword" prefix-icon="el-icon-lock"
            :show-password="true"></el-input>
        </el-form-item>
        <el-form-item prop="mobile" class="login-item">
          <el-input placeholder="请输入手机号" prefix-icon="el-icon-mobile" v-model="registerForm.mobile"></el-input>
        </el-form-item>
        <el-form-item prop="verifycode" class="login-item">
          <el-input placeholder="请输入短信验证码" prefix-icon="el-icon-message" v-model="registerForm.verifycode">
            <el-button type="text" slot="suffix" :disabled="countdown" @click="getVerifyCode">{{ buttonText }}</el-button>
          </el-input>
        </el-form-item>

        <el-form-item prop="manageType" class="login-item" style="text-align: left;">
          <span>企业类型：</span>
          <!-- <el-radio-group v-model="registerForm.manageType" size="mini">
            <el-radio-button label="2">产废单位</el-radio-button>
            <el-radio-button label="1">处置单位</el-radio-button>
          </el-radio-group> -->
          <el-radio v-model="registerForm.manageType" label="2">产废单位</el-radio>
          <el-radio v-model="registerForm.manageType" label="1">处置单位</el-radio>
        </el-form-item>

        <div class="rememberPwd">
          <el-checkbox v-model="isAgree">勾选并同意<span style="color: #409eff">《用户服务协议》</span></el-checkbox>
        </div>
        <el-form-item>
          <el-button style="width: 100%; margin-top: 20px; letter-spacing: 12px" type="danger" :disabled="!isAgree"
            class="btn-ok" @click="onSubmit()">注册</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    let repeatValidate = (rule, value, callback) => {
      if (value != this.registerForm.password) {
        callback(new Error("两次密码输入不一致"));
      } else if (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z\x21-\x7e]{6,18}$/.test(value)) {
        callback();
      } else {
        callback(new Error("请输入包含英文字母大小写、数字和特殊符号的 6-18 位组合"));
      }
    };
    return {
      countdown: false, // 表示按钮是否处于倒计时状态
      timeLeft: 60, // 表示剩余时间
      registerForm: {
        companyName: "",
        uniformSocialCreditCode: "",
        password: "",
        repeatPassword: "",
        mobile: "",
        verifycode: "",
        manageType: '2'
      },
      isAgree: false,
      rules: {
        companyName: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "blur",
          },
        ],
        uniformSocialCreditCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "blur",
          },
          {
            pattern: /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/,
            message: "统一社会信用代码格式有误",
            trigger: "blur",
          },
        ],
        //
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            pattern: /^(?![A-z0-9]+$)(?=.[^%&',;=?$\x22])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{6,20}$/,
            message: "密码长度为6~20位，必须包含大小写字母、符号、数字。",
            trigger: "blur",
          },
        ],
        repeatPassword: [
          { required: true, message: "请再输入一遍密码", trigger: "blur" },
          { validator: repeatValidate, trigger: "blur" },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式有误",
            trigger: "blur",
          },
        ],
        verifycode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
          {
            pattern: /^\d{6}$/,
            message: "验证码格式有误",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    buttonText() {
      return this.countdown ? `${this.timeLeft}` : "获取验证码";
    },
  },
  methods: {
    linkTo(page) {
      this.$emit("linkTo", page);
    },
    //获取验证码
    getVerifyCode() {
      if (!/^1[3-9]\d{9}$/.test(this.registerForm.mobile)) {
        this.$message.error("请输入正确的手机号");
        return;
      }
      let url = this.$api.appUsers.sendSmsNotAuth;
      let parames = {
        mobile: this.registerForm.mobile,
        smsUseto: 0,
      };
      this.$axios
        .get(url, parames, false)
        .then((res) => {
          if (res.data.code === 0) {
            this.countdown = true;
            let timeInterval = setInterval(() => {
              this.timeLeft--;
              if (this.timeLeft === 0) {
                clearInterval(timeInterval);
                this.countdown = false;
                this.timeLeft = 60;
              }
            }, 1000);
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        })
        .catch((err) => {
          console.log("失败");
        });
    },
    //注册
    onSubmit() {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          let url = this.$api.appUsers.register;

          let { repeatPassword, ...postData } = this.registerForm;
          this.$axios
            .post(url, this.$qs.stringify(postData), false)
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.linkTo('login')
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.center-box-register {
  width: 550px;
  height: 600px;
  background: #ffffff;
  background-size: 100% 100%;
  text-align: center;
  margin: auto;
  border-radius: 2px;

  .register-header {
    display: flex;
    justify-content: space-between;

    .register-title {
      text-align: left;
      padding-top: 20px;
      padding-left: 50px;
      font-size: 18px;
      font-weight: 800;
    }

    .link-login {
      cursor: pointer;
      padding: 30px 50px 0px 0px;
      color: #409eff;
      font-size: 12px;
      font-weight: bold;
    }
  }

  .center-box-main {
    padding: 10px 100px;
  }
}
</style>
